import { render, staticRenderFns } from "./Palette.vue?vue&type=template&id=04b61512&scoped=true"
import script from "./Palette.vue?vue&type=script&lang=js"
export * from "./Palette.vue?vue&type=script&lang=js"
import style0 from "./Palette.vue?vue&type=style&index=0&id=04b61512&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b61512",
  null
  
)

export default component.exports